import React, { useEffect } from 'react';
import { CrudAppointmentActions } from "./hooks/useSchedules";
import { BookingModal } from "./modals/BookingModal";
import Drawer from "./ui/Drawer";
import PaymentPanel from "./panels/PaymentPanel";
import CheckoutPanel from "./panels/CheckoutPanel";
import editRepeatAppointment from "../components/repeatAppointmentScreens/editRepeatAppointment/editRepeatAppointment";
import { useBreakpoint } from "../../utils/useBreakpoint";
import MyCalendar from "./MyCalendar";
import { useCalendarState } from "./hooks/useCalendarState";
import { ServiceModal } from "./modals/ServiceModal";
import {
    useCreateAppointmentScreen
} from "../components/crudAppointmentScreens/createAppointmentScreen/useCreateAppointmentScreen";
import ProductModal from "./modals/ProductModal";
import { useSelector } from "react-redux";
import { selectProducts } from "../../redux/productSlice";
import { useUpdateAppointment } from "./hooks/useUpdateAppointment";
import { useUpdateAppointmentNew } from "./hooks/useUpdateAppointmentNew";
import QuickCheckoutModal from './modals/QuickCheckoutModal';


interface TimeSlot {
    day: number;
    timeSlot: number;
}

const Calendar: React.FC = () => {

    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const timeSlots = [
        '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
        '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM'
    ];

    const { isBelowSm } = useBreakpoint("sm");

    const { products, categories, loading } = useSelector(selectProducts);

    const {
        isLoading,
        date,
        employees,

        events,
        setEvents,
        blockedTimes,
        handleNavigate,
        handleViewChange,
        handleSelectEvent,
        handleSelectSlot,
        handleEventDrop,
        handleEventResize,
        showBookingModal,
        setShowBookingModal, resourceMap,
        showQuickCheckout,
        setShowQuickCheckout,
        calendarView,
        setCalendarView,
        setSelectedEvent,
        selectedEvent,

        selectedEmployee,
        selectedEmployeeId,
        setSelectedEmployee,

        pendingAppointment,
        setPendingAppointment,

        setAppointmentDrawer,
        appointmentDrawer,


        // schedules
        getWeeklySchedulesOfEmployees,
        getSchedulesOfEmployees,
        updateCalendarData,

        toggleAppointmentDrawer,


        createNewPendingAppointment,
        onNewAppointmentInit,
        onQuickCheckout,

        shops,
        shop, isDoingPayment, setIsDoingPayment,


        // addServiceModal,
        // setAddServiceModal,
        // addProductModal,
        // setAddProductModal,
        // handleCloseServiceModal,
        // setAddServiceModal

    } = useCalendarState();


    const {
        employee,
        clients,
        isDateInputFocused,
        setIsDateInputFocused,
        onSubmit,
        onHandleClientChange,
        selectedClient,
        setSelectedClient,
        selectedServices,
        onHandleAddService,
        selectedDate,
        setSelectedDate,
        availableServices,
        serviceSelectValue,
        editingEmployeeInServiceIndex,
        setEditingEmployeeInServiceIndex,
        handleEmployeeChange,
        employeeSelectRef,
        onRemoveService,
        handleClientSearch,
        onDateChange,
        onTimeChange,

        addServiceModal,
        setAddServiceModal,
        addProductModal,
        setAddProductModal,
    } = useCreateAppointmentScreen({
        pendingAppointment: selectedEvent,
        setPendingAppointment,
        toggleAppointmentDrawer,
        getSchedulesOfEmployees,
        getWeeklySchedulesOfEmployees,
        selectedEmployee,
        calendarView,
        updateCalendarData,
    });

    useEffect(() => {
        if (!selectedEvent) return;

        const updated = events.find((e: any) => e.id === selectedEvent.id);

        if (updated) {
            setSelectedEvent({ ...updated });
        }
    }, [events]);
    console.log("events", events);




    const handleServiceModal = (isOpen: boolean) => {
        setAddServiceModal(isOpen)
    }
    const handleProductModal = (isOpen: boolean) => {
        setAddProductModal(isOpen)
    }
    const handleProceedToPayment = () => {
        setIsDoingPayment(true)
    };
    //
    const handleBackFromPayment = () => {
        setIsDoingPayment(false)
    };


    return (
        <div className="p-4 flex-col flex bg-gray-50">
            <div>
                <div className="flex items-center justify-between">
                    <h1 className="text-2xl font-semibold text-gray-900">Calendar</h1>
                </div>


                <div className={'p-4 mt-4 bg-white rounded-lg shadow-sm border border-gray-200'}>


                    {/*{!isBelowSm && <Toolbar*/}
                    {/*    onNewAppointmentInit={onNewAppointmentInit}*/}
                    {/*    employees={employees}*/}
                    {/*    setSelectedWeeklyEmployee={setSelectedWeeklyEmployee}*/}
                    {/*    selectedWeeklyEmployee={selectedWeeklyEmployee}*/}
                    {/*    currentDate={date}*/}
                    {/*    calendarView={calendarView as CalendarViewType}*/}
                    {/*    onNavigate={(action: "prev" | "next" | "today") => {*/}
                    {/*        onNavigate(date, calendarView, action);*/}
                    {/*    }}*/}
                    {/*    onViewChange={setCalendarView}*/}
                    {/*    resources={resourceMap}*/}
                    {/*    selectedResourceId={undefined}*/}
                    {/*/>}*/}


                    <div className={'h-full overflow-y-scroll'}>

                        {
                            // (isBelowSm) ?
                            //     (
                            //         <MobileSchedule selectedEmployee={selectedEmployee}
                            //                      setSelectedEmployee={setSelectedEmployee}
                            //                      appointments={appointments} date={date}
                            //                      toggleAppointmentDrawer={toggleAppointmentDrawer}
                            //                      onAppointmentSelect={onAppointmentSelect}
                            //                      createNewPendingAppointment={createNewPendingAppointment}
                            //                      currentShopTime={currentShopTime}
                            //                      onCustomNavigate={onCustomNavigate}/>
                            //     )
                            //     :
                            //     renderCalendarView()
                            // }

                        }

                        <MyCalendar employees={employees}
                            selectedEmployeeId={selectedEmployeeId}
                            isLoading={isLoading}
                            date={date}
                            resourceMap={resourceMap}
                            view={calendarView as 'day' | 'week' | 'month'}
                            events={events}
                            blockedTimes={blockedTimes}
                            setEvents={setEvents}
                            handleNavigate={handleNavigate}
                            handleViewChange={handleViewChange}
                            handleEmptySlotClick={handleSelectSlot}
                            handleNewAppointmentClick={onNewAppointmentInit}
                            handleQuickCheckOutClick={onQuickCheckout}
                            handleAppointmentClick={(event) => handleSelectEvent(event)}
                            handleBlockedClick={(event) => {
                            }}
                            handleOfftimeClick={(event) => {
                            }}
                            handleEventDrop={({ event, start, end }) => {
                                setEvents((prev) =>
                                    prev.map((ev) =>
                                        ev.id === event.id ? {
                                            ...ev,
                                            start: new Date(start),
                                            end: new Date(end)
                                        } : ev
                                    )
                                );
                            }}
                            selectedEmployee={selectedEmployee}
                            setSelectedEmployee={setSelectedEmployee}
                            shops={shops}
                            shop={shop}
                        />

                    </div>


                    <Drawer isOpen={appointmentDrawer.isOpen && appointmentDrawer.type === CrudAppointmentActions.READ}
                        onClose={() => {
                            setIsDoingPayment(false);
                            setAppointmentDrawer({ isOpen: false, type: null });
                        }}>


                        {

                            (isDoingPayment ? (
                                <PaymentPanel
                                    setAppointmentDrawer={setAppointmentDrawer}
                                    onBack={handleBackFromPayment}
                                    onClose={() => {
                                        setIsDoingPayment(false)
                                        setAppointmentDrawer({ isOpen: false, type: null })
                                    }}

                                    appointment={selectedEvent}
                                    updateCalendarData={updateCalendarData}
                                    onPaymentSuccess={() => console.log("Payment done!")} />) :

                                (<CheckoutPanel
                                    setAppointmentDrawer={setAppointmentDrawer}
                                    getSchedulesOfEmployees={getSchedulesOfEmployees}
                                    updateCalendarData={updateCalendarData}
                                    toggleAppointmentDrawer={toggleAppointmentDrawer}
                                    setPendingAppointment={setPendingAppointment}
                                    closeDrawer={() =>
                                        setAppointmentDrawer({ isOpen: false, type: null })
                                    }
                                    // onMakeAppointmentRepeating={openMakeRepeatAppointmentModal}
                                    // onStopAppointmentRepeating={openStopRepeatAppointmentModal}
                                    onEditAppointmentRepeating={editRepeatAppointment}
                                    proceedToPayment={handleProceedToPayment}
                                    selectedAppointmentEvent={selectedEvent}
                                    setSelectedAppointmentEvent={setSelectedEvent}
                                    show={appointmentDrawer.isOpen}
                                    setAddServiceModal={() => handleServiceModal(true)}
                                    setAddProductModal={() => handleProductModal(true)}
                                    onClose={() => {
                                        setIsDoingPayment(false)
                                        setAppointmentDrawer({ isOpen: false, type: null })

                                    }}
                                    events={events} />
                                ))
                        }

                    </Drawer>

                    {showBookingModal &&
                        <BookingModal
                            pendingAppointment={pendingAppointment}
                            setPendingAppointment={setPendingAppointment}
                            getWeeklySchedulesOfEmployees={getWeeklySchedulesOfEmployees}
                            selectedEmployee={selectedEmployee}
                            setSelectedEmployee={setSelectedEmployee}
                            calendarView={calendarView}
                            onClose={() => setShowBookingModal(false)}
                            isOpen={showBookingModal}

                            // createNewPendingAppointment={createNewPendingAppointment}
                            toggleAppointmentDrawer={() => {
                            }}
                            getSchedulesOfEmployees={getSchedulesOfEmployees}
                            events={events}
                            updateCalendarData={updateCalendarData}
                        />}

                    {showQuickCheckout && (
                        <QuickCheckoutModal
                            onClose={() => setShowQuickCheckout(false)}
                            onComplete={() => { }}
                        />
                    )}
                </div>
            </div>



        </div>
    );
};

export default Calendar;
